<div class="toast" [ngClass]="toaster.type" *ngIf="toaster.message" cy-elm="toast">
	<span class="message"><strong>{{toaster.type}}: </strong> <span cy-elm="toast-message" [innerHtml]="toaster.message"></span></span>
	<i class="material-icons close" (click)="toaster.closeMessage()" *ngIf="toaster.closable" cy-elm="toast-close">
		close
	</i>
</div>
